import React from 'react';
import { Helmet } from 'react-helmet';
import './Qualite.css';
import { Breadcrumb } from "antd";
import Footer from '../../Footer';
import PartnerCarousselQ from './PartnerCarousselQ';
import { useTranslation } from 'react-i18next';

const Qualite = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="wrapper_CTL_Q">
      {/* Helmet pour gérer les métadonnées SEO */}
      <Helmet>
        <title>{t('Gestion de Qualité - Professional Inspectors')}</title>
        <meta name="description" content="Découvrez notre engagement envers la qualité. Certification ISO 9001, ISO 45001, ISO 14001. Accréditation Veritas. Qualification des personnels dans les contrôles non destructifs, soudage, sécurité et plus." />
        <meta name="keywords" content="contrôle qualité, ISO 9001, ISO 45001, ISO 14001, accréditation Veritas, contrôle non destructif, inspection de soudage, qualification du personnel, sécurité au travail, inspection de sécurité périodique, mesure d'épaisseur des navires, direction de sécurité" />
      </Helmet>
      <div className="container_15 ">
        <Breadcrumb separator=">">
          <Breadcrumb.Item href="/">Accueil</Breadcrumb.Item>
          <Breadcrumb.Item >Qualité</Breadcrumb.Item>
        </Breadcrumb>

        {/* Section Orientation client */}
        <div className="content-wrapper">
          <h1 className="custom-title">{t('Orientation client')}</h1>
          <div className="text-with-image">
            <div className="text">
                <p> {t('La politique de qualité de PI met l\'accent sur les axes suivants :')}</p>
             <p> {t('• L’Ecoute de nos clients pour connaître leurs exigences et aller au-delà de leurs attentes.')}</p>
             <p> {t('• Le Contrôle qualité de nos prestations et de nos rapports et certificats finaux.')}</p>
             <p> {t('• L’Amélioration continue via un système d’audits internes et d’un ensemble d’indicateurs de performance des processus.')}</p>
             <p> {t('• La qualification du personnel en assurant la formation interne et externe nécessaire.')}</p>
            </div>
            <img className="img1" src="/images/certif.png" alt="Qualité 1" loading="lazy"/>
          </div>
        </div>

        {/* Section Système de la management intégrer (SMI) */}
        <div className="content-wrapper2">
          <h1 className="custom-title">{t('Système de management intégré')}</h1>
          <h1 className="custom-title2">{t('(SMI)')}</h1>
          <div className="text-smi">
                <p> {t('Tout est mis en œuvre pour obtenir des résultats satisfaisants grâce à la mise à disposition de :')}</p>
            <p> {t('• Des personnels hautement qualifiés et professionnellement expérimentés.')}</p>
            <p> {t('• Des équipements bien entretenu et très diversifié.')}</p>
            <p> {t('• Un ensemble approuvé des procédures de travail appropriées et actualisées.')}</p>
            <p> {t('• Un travail précis et bien défini.')}</p>
            <p> {t('• Des opérations d\'exécution bien préparées et planifiées de manière cohérente.')}</p>
            </div>
          {/* Qualité */}
          <h6 className="t1">{t('Certification systeme de qualité :')}</h6>
          <div className="text-with-image">
            <div className="text2">
            <p> {t('• Notre bureau de contrôle «PROFESSIONAL INSPECTORS SA» est certifié en Qualité selon ISO 9001 version 2015 et iso 17020 version 2012.')}</p> 
            </div>
          </div>
          <div className="content-wrapper2_1">
            <img className="img2" src="/images/qualite2.1.png" alt="Qualité 1" loading="lazy"/>
            <img className="img2" src="/images/qualite2.2.png" alt="Qualité 2" loading="lazy"/>
          </div>

          {/* Santé */}
          <h6 className="t1">{t('Certification systeme Santé et securité :')}</h6>
          <div className="text-with-image">
            <div className="text2">
              <p>{t('• Notre bureau de contrôle «PROFESSIONAL INSPECTORS SA» est certifié en santé et sécurité de travail selon ISO 45001 version 2018.')}</p>
            </div>
          </div>
          <div className="content-wrapper2_1">
            <img className="img2" src="/images/qualite3.png" alt="Qualité 3" loading="lazy"/>
                    </div>

                    {/* Environnement */}
                    <h6 className="t1">{t('Environment Protection system recognition :')}</h6>
                    <div className="text-with-image">
                        <div className="text2">
                            <p>{t('• Notre bureau de contrôle «PROFESSIONAL INSPECTORS SA» est certifié en protection de l’environnement conformément a ISO 14001 version 2015.')}</p>
                        </div>
                    </div>
                    <div className="content-wrapper2_1">
                        <img className="img2" src="/images/qualite4.png" alt="Qualité 4" loading="lazy"/>
                    </div>

                    {/* Accréditation Veritas */}
                    <h6 className="t1">{t('Accréditation Veritas :')}</h6>
                    <div className="text-with-image">
                        <div className="text2">
                            <p>{t('• Notre bureau de contrôle «PROFESSIONAL INSPECTORS SA» dispose d’un agrément en contrôle périodique de sécurité et en contrôle officiel du ministère de l’industrie. Notre bureau de contrôle «PROFESSIONAL INSPECTORS SA» dispose d’un agrément en contrôle de mesure des épaisseurs des navires de la société de classe BV.')}</p>
                        </div>
                    </div>
                    <div className="content-wrapper2_1">
                        <img className="img3" src="/images/qualite5new.png" alt="Qualité 5" loading="lazy"/>
                    </div>
                </div>

                {/* Qualification des personnels */}
                <div className="content-wrapper2">
                    <h1 className="custom-title">{t('Qualification des personnels')}</h1>
                    <div className="text-with-image">
                        <div className="text3">
                            <p>{t('Notre personnel se compose d\'ingénieurs, des inspecteurs et des experts hautement qualifiés et certifiés par des organismes agréés pour la qualification dans les contrôles non destructifs niveau I &IICND tels que LE CETIME, l’ASNT, API, NS-2,la radioprotection par le CNRP.')}
                                {t('Ils sont aussi habilités à la rédaction et l’approbation des procédures de soudage, des procédures de qualification des soudeurs et à l’inspection de soudage en qualité de spécialistes internationaux en soudage ou Ingénieurs internationaux en Soudage accrédités par des organismes de renommés tel que CETIME, IS et IWS.')}
                                {t('Ils sont également agréés par la direction de sécurité au sein du ministère de l’industrie pour la certification des équipements engins et accessoires de levage et de manutention, des installations intérieures de gaz, des appareils à pression de transport d’hydrocarbures, des appareils à pression à vapeur ou à gaz et les installations intérieures électriques.')}</p>
                        </div>
                    </div>
                </div>
                <div className="container">
            <table className="table table-sm table-bordered">
            <tbody>
  <tr>
    <td>{t('Contrôle Non Destructif')}</td>
    <td>{t('Agrément de L\'API N°SDV 090026B')}</td>
  </tr>
  <tr>
    <td>{t('Contrôle par Radiographie')}</td>
    <td>{t('Agrément de L\'API N°SDV 090026B')}</td>
  </tr>
  <tr>
    <td>{t('Contrôle par Magnétoscopie')}</td>
    <td>{t('Agrément de L\'API N°SDV 090026B')}</td>
  </tr>
  <tr>
    <td>{t('Contrôle par ressuage')}</td>
    <td>{t('Agrément de L\'API N°SDV 090026B')}</td>
  </tr>
  <tr>
    <td>{t('Contrôle par Ultrason')}</td>
    <td>{t('Agrément de L\'API N°SDV 090026B')}</td>
  </tr>
</tbody>
</table>
</div>

<br />
<div className="container">
  <table className="table table-sm table-bordered">
    <tbody>
      <tr>
        <td>{t('A1')}</td>
        <td>{t('Epreuve Hydraulique Officielle des appareils à Vapeur')}</td>
      </tr>
      <tr>
        <td>{t('A2')}</td>
        <td>{t('Epreuve hydraulique officielle des appareils à pression de gaz')}</td>
      </tr>
      <tr>
        <td>{t('A3')}</td>
        <td>{t('Epreuve hydraulique officielle des ouvrages de transport de gaz combustibles par canalisation.')}</td>
      </tr>
      <tr>
        <td>{t('B1')}</td>
        <td>{t('Certification des installations de gaz dans les domaines industriels.')}</td>
      </tr>
      <tr>
        <td>{t('B2')}</td>
        <td>{t('Certification des installations électriques dans les domaines industriels.')}</td>
      </tr>
      <tr>
        <td>{t('B3')}</td>
        <td>{t('Certification des appareils de levage et des ascenseurs.')}</td>
      </tr>

    </tbody>
  </table>
</div>

            </div>
            <PartnerCarousselQ />
            <Footer />
        </div>
    )
}

export default Qualite;
